import React from "react";
import { Navigate } from "react-router-dom";
import { useHomePath, useModePending } from "@/lib/uiMode";
import { SHELL } from "@/constants/testIds";

/**
 * Destino de "casa": serve `/` e o catch-all das rotas protegidas.
 *
 * P0.3 — o destino passa a vir de `homePathFor`: `/hoje` em modo operador,
 * `/dashboard` em todos os outros casos (incluindo flag desligada).
 *
 * P0.6 — antes de saber o modo não se salta para lado nenhum. Sem isto um
 * operador aterrava no Dashboard e só depois era atirado para `/hoje` — dois
 * ecrãs e um flash por cada arranque.
 */
export default function HomeRedirect() {
  const homePath = useHomePath();
  const modePending = useModePending();

  if (modePending) {
    return (
      <div
        data-testid={SHELL.routeLoading}
        className="min-h-screen flex items-center justify-center bg-surface-bg text-ink-secondary text-sm"
      >
        A carregar…
      </div>
    );
  }

  return <Navigate to={homePath} replace />;
}
